module.exports = __webpack_public_path__ + "static/020-2d9ab2df77f4d9f3afecd96121ff3674.jpg";